import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Swal from 'sweetalert2';
import {
  Button,
  Card,
  Container,
  Row,
  Col,
} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import moment from 'moment';

import { getPopupList, deletePopup } from 'apis/admin/pageApi';

import SimpleHeader from 'components/Headers/SimpleHeader.js';

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPageRenderer: ({ options, currSizePerPage, onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        }
      </label>
    </div>
  ),
  paginationTotalRenderer: (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      { from } - { to } / Total { size }
    </span>
  ),
});

const { SearchBar } = Search;

function Popup() {
  const user = useSelector(state => state.user);
  
  const history = useHistory();

  const componentRef = useRef();
  const [popupList, setPopupList] = useState([]);
  const [checked, setChecked] = useState([]);

  // 팝업 가져오기
  const getAllPopup = async () => {
    setPopupList([]);
    await getPopupList()
      .then(response => {
        if (response.data.success) {
          setPopupList(response.data.result);
        }
      })
      .catch(error => {
        console.error('error occured in Page/Popup/Popup.js - getAllPopup() ', error);

        Swal.fire({
          icon: 'error',
          title: '팝업 데이터를 불러올 수 없습니다.',
          text: '잠시 후 다시 시도해주세요.',
        }).then(() => {
          return;
        });
      });
  };

  useEffect(() => {
    getAllPopup();
  }, []);

  // 테이블 컬럼
  const columns = [
    {
      dataField: 'id',
      text: '번호',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      searchable: false,
    },
    {
      dataField: 'title',
      text: '제목',
      sort: true,
      headerAlign: 'center',
      align: 'center',
    },
    {
      dataField: 'device',
      text: '접속 기기',
      sort: false,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell) => (
        cell === 'all' ? '모든 기기' : cell === 'pc' ? 'PC' : '모바일'
      ),
    },
    {
      dataField: 'start_date',
      text: '시작 일시',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      formatter: (cell) =>
        (cell && moment(cell).format('YYYY[-]MM[-]DD')) || '-',
    },
    {
      dataField: 'end_date',
      text: '종료 일시',
      sort: false,
      headerAlign: 'center',
      align: 'center',
      searchable: false,
      formatter: (cell) =>
        (cell && moment(cell).format('YYYY[-]MM[-]DD')) || '-',
    },
    {
      dataField: 'activated',
      text: '활성화 여부',
      sort: false,
      headerAlign: 'center',
      align: 'center',
      searchable: false,
      formatter: (cell) => (
        cell === 1 || cell ? '활성화' : '비활성화'
      ),
    },
    {
      dataField: '',
      text: '수정',
      sort: false,
      headerAlign: 'center',
      align: 'center',
      searchable: false,
      formatter: (cell, row) => (
        <Link to={`/admin/pages/popup/edit/${row.id}`}>
          <i className="fas fa-edit text-primary" />
        </Link>
      ),
    },
  ];

  // 데이터 선택
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: false,
    // nonSelectable: nonSelectableArr,
    onSelect: (row) => {
      const currentChecked = checked.indexOf(row.id);
      const newChecked = [...checked];

      if (currentChecked === -1) {
        newChecked.push(row.id);
      } else {
        newChecked.splice(currentChecked, 1);
      }

      setChecked(newChecked);
    },
    onSelectAll: (isSelect, rows) => {
      if (isSelect) {
        const newChecked = [];
        rows.map((val) => newChecked.push(val.id));
  
        setChecked(newChecked);
      } else {
        setChecked([]);
      }
    },
  };

  // 선택한 팝업 삭제
  const deleteSelected = async () => {
    Swal.fire({
      title: '선택한 팝업을 삭제하겠습니까?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '선택 삭제',
      cancelButtonText: '취소',
      confirmButtonColor: '#f5365c',
    }).then(async (value) => {
      if (value.isConfirmed) {
        await deletePopup(checked)
          .then(async (response) => {
            if (response.data.success) {
              setChecked([]);
              await getAllPopup();
            }
          })
          .catch((error) => {
            console.error(
              'error occured in Popup.js - deleteSelected() ',
              error
            );

            Swal.fire({
              icon: 'error',
              title: '팝업을 삭제할 수 없습니다.',
              text: '잠시 후 다시 시도해주세요.',
            }).then(() => {
              return;
            });
          });
      } else {
        Swal.close();
      }
    });
  };

  return (
    <div>
      <SimpleHeader parentName="페이지 설정" name="팝업 관리" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
            <ToolkitProvider
                data={popupList}
                keyField="id"
                columns={columns}
                search
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Container fluid>
                      <Row>
                        <Col xs={12} sm={6}>
                          <div
                            id="datatable-basic_filter"
                            className="dataTables_filter"
                          >
                            <label>
                              <span className="text-sm mr-2">
                                <i className="fas fa-search text-muted" />
                              </span>
                              <SearchBar
                                className="form-control-sm"
                                {...props.searchProps}
                                placeholder="제목, 기간"
                              />
                            </label>
                          </div>
                        </Col>
                        <Col xs={12} sm={6}>
                          {user && user.userData && user.userData.isAdmin && (
                            <div className="px-2 pb-1 float-right">
                              <>
                                {checked.length > 0 && (
                                  <Button
                                    color="danger"
                                    size="sm"
                                    onClick={deleteSelected}
                                  >
                                    선택 삭제
                                  </Button>
                                )}
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => history.push({
                                    pathname: '/admin/pages/popup/create',
                                  })}
                                >
                                  팝업 추가
                                </Button>
                              </>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Container>
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={false}
                      selectRow={selectRow}
                      noDataIndication={() => <div className="text-center text-muted">데이터가 없습니다.</div>}
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </Row>
      </Container>
    </div>
  );
}

export default Popup;
